import { makeStyles } from "@material-ui/core/styles";
export const useReceiptStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
    position: "fixed",
    bottom: 0,
    backgroundColor: theme.palette.primary.main,
    color: "white",
  },
  receiptContainer: {
    flexGrow: 1,
    paddingBottom: "65px",
  },
  buttonsList: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  button: {
    margin: theme.spacing(3, 0, 2),
  },
  receiptList: {
    paddingTop: "60px",
    paddingBottom: "45px",
    height: "100vh auto",
    backgroundColor: "transparent",
  },
  listItem: {
    boxSizing: "border-box",
    borderRadius: 8,
    borderStyle: "solid",
    borderWidth: 0,
    borderColor: "black",
    backgroundColor: theme.palette.type === "dark" ? "#042337" : "#fff",
    color: theme.palette.type === "dark" ? "#ffffff" : "#000000",
    margin: theme.spacing(1, 0),
    padding: theme.spacing(1.5),
    height: "58px",
  },
  listItemText: {
    //maxWidth: "220px",
  },
  listItemTextPrimary: {
    fontFamily: "Helvetica",
    fontWeight: 501,
    fontSize: "0.813rem",
    color: theme.palette.type === "dark" ? "#ffffff" : "#000000",
  },
  listItemDate: {
    fontFamily: "Helvetica",
    fontSize: "0.75rem",
    fontWeight: 501,
    paddingTop: "2px",
    color: theme.palette.type === "dark" ? "#ffffff" : "#000000",
  },
  listItemTextSecondary: {
    fontFamily: "Helvetica",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxHeight: "50px",
    color: "#78987E",
    fontSize: "0.75rem",
  },
  listItemSecondary: {
    paddingTop: "20px",
    height: "100%",
  },
  inline: {
    display: "inline",
    wordBreak: "break-word",
  },
  receiptImgContainer: {
    maxWidth: window.innerWidth - 130,
    margin: 15,
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  receiptImg: {
    width: "100px",
    height: "auto",
  },
  formControl: {
    margin: theme.spacing(3, 0, 1, 0),
  },
  bottomNavButton: {
    color: "white",
    textTransform: "uppercase",
  },
  fileUploadContainer: {
    boxSizing: "border-box",
    height: "100%",
    padding: theme.spacing(3, 0),
  },
  fileUploadButton: {
    width: "100%",
    margin: theme.spacing(3, 0, 1, 0),
  },
  subToolBarVerticalContainer: {
    position: "fixed",
    top: "56px",
    left: 0,
    right: 0,
    background: "linear-gradient(to top, rgba(0, 61, 92, 0) 0%, rgba(0, 61, 92, 1) 100%)",
    backdropFilter: "blur(15px)",
    WebkitBackdropFilter: "blur(15px)",
    display: "flex",
    flexDirection: "column",
    height: "55px",
    justifyContent: "center",
    zIndex: 100,
  },
  subToolBar: {
    backgroundColor: "transparent",
    display: "flex",
    flexDirection: "row",
    //height: "55px",
    paddingRight: "10px",
    //justifyContent: "center",
  },
  cameraPreviewsContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    padding: 13,
    width: "100%",
  },
  cameraPreviewItem: {
    margin: 3,
  },
  cameraPreviewImg: {
    width: 50,
    borderRadius: "8%",
  },
  searchContainer: {
    margin: 0,
    padding: 0,
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#157D3A",
    },
    "& .MuiInputLabel-outlined.Mui-focused": {
      color: "black",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-input": {
      color: "black",
    },
  },
  searchInput: {
    ///height: "35px",
    borderColor: "black",
    backgroundColor: "#ffffff",
    //fontSize: "12px",
  },
  listSubheader: {
    color: "#ffffff",
    paddingLeft: 0,
    backgroundColor: "transparent",
    lineHeight: 1.2,
  },
}));
